
import React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Text } from 'office-ui-fabric-react';
import { FontIcon } from "office-ui-fabric-react";

const classNames = mergeStyleSets({
    heading: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #000000',
        paddingTop: '1em'
    },

    icon: {
        marginRight: '1em'
    },

    label: {
        padding: '1em 0em',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end'
    },

    options: {
        width: '100%'
    }
})

const PricelistEditor = ({
    onCollapseAllClick,
    onEditTitleClick,
    onExpandAllClick,
    onPricelistSaveClick,
    operationList,
    pricelistTitle,
    readOnly
}) => {

    const handleCollapseAllClick = () => {
        if (onCollapseAllClick) {
            onCollapseAllClick();
        };
    }

    const handleExpandAllClick = () => {
        if (onExpandAllClick) {
            onExpandAllClick();
        };
    }

    const handleEditTitle = () => {
        if (onEditTitleClick) {
            onEditTitleClick();
        }
    }

    const handleSavePricelistClick = () => {
        if (onPricelistSaveClick) {
            onPricelistSaveClick();
        }
    }

    return (
        <Stack>
            <Stack className={classNames.heading}>
                <Text variant={'mediumB'}>Ceník prací a materiálů:</Text>
            </Stack>
            <Stack className={classNames.label}>
                <Stack.Item grow>
                    <FontIcon className={classNames.icon} iconName="GripperDotsVertical"></FontIcon>
                    <Text variant={'medium'}>{pricelistTitle}</Text>
                </Stack.Item>
                {readOnly &&
                    <Text>Ceník nelze editovat</Text>
                }
                {!readOnly &&
                    <DefaultButton iconProps={{iconName: "Edit"}} onClick={handleEditTitle} text="Upravit název" />
                }
            </Stack>
            <Stack horizontal className={classNames.label} tokens={{childrenGap: 5}}>
                <DefaultButton className={classNames.options} iconProps={{iconName: "DoubleChevronDown12"}} onClick={handleExpandAllClick}>Rozbalit vše</DefaultButton>
                <DefaultButton className={classNames.options} iconProps={{iconName: "DoubleChevronUp12"}} onClick={handleCollapseAllClick}>Sbalit vše</DefaultButton>
                <DefaultButton className={classNames.options} iconProps={{iconName: "Save"}} onClick={handleSavePricelistClick}>Uloži ceník do souboru</DefaultButton>
            </Stack>
            {operationList}
        </Stack>
    );
}

export default PricelistEditor;
